import dayjs from 'dayjs';
import { getSalesDashboardData } from './ReportsSalesService';
import { getBranchDashboardData } from './ReportsBranchService';
import { getInventoryDashboardData } from './ReportsInventoryService';

class DashboardService {
  // Obtener todos los datos del dashboard usando los endpoints existentes
  // TODO: Cuando el backend implemente /dashboard, cambiar a usar ese endpoint
  async getDashboardData({ month = null, year = null, allowedCategories = [] } = {}) {
    try {
      const currentMonth = month || dayjs().month() + 1;
      const currentYear = year || dayjs().year();
      const enabledCategories = new Set(allowedCategories);

      // Usar los endpoints existentes de reportes
      const [sales, branch, inventory] = await Promise.all([
        enabledCategories.has('sales')
          ? getSalesDashboardData({ month: currentMonth, year: currentYear }).catch(() => null)
          : Promise.resolve(null),
        enabledCategories.has('branch')
          ? getBranchDashboardData({ month: currentMonth, year: currentYear }).catch(() => null)
          : Promise.resolve(null),
        enabledCategories.has('inventory')
          ? getInventoryDashboardData({ month: currentMonth, year: currentYear }).catch(() => null)
          : Promise.resolve(null),
      ]);

      return {
        sales,
        branch,
        inventory,
        month: currentMonth,
        year: currentYear
      };
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
}

export default new DashboardService();
